import { faQuestionCircle as Required } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Grid, MenuItem, TextField, Tooltip } from '@material-ui/core';
import { lowerFirst } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { anyGuid, emptyGuid } from '../../../utils/constants';
import { combineClasses } from '../../../utils/styling';
import { useStyles } from './styles';

export const ApplyTemplateToAllPositions = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [positionTemplateId, setPositionTemplateId] = useState(emptyGuid);

  const templateOptionLabel = positionTemplate =>
    `${
      (positionTemplate.archived
        ? `[${t('positionTemplate.archived')}] `
        : '') + positionTemplate.name
    } ${t('fieldsAndTemplatesPage.usage', {
      positionCount: positionTemplate.positionCount,
    })}`;

  useEffect(() => {
    setPositionTemplateId(emptyGuid);
  }, [props.filters]);

  const renderActivePositionTemplates = () => {
    const positionTemplates =
      props.templateOptions[`${lowerFirst(props.filters.positionType)}Options`];

    if (!positionTemplates) {
      return null;
    }

    return positionTemplates
      .filter(positionTemplate => !positionTemplate.archived)
      .map(template => (
        <MenuItem
          key={template.positionTemplateId}
          value={template.positionTemplateId}
        >
          {templateOptionLabel(template)}
        </MenuItem>
      ));
  };

  const handleApplyAllClick = () => {
    props.handleApplyToAllAction(positionTemplateId);
  };

  return (
    <Grid container item xs={12} className={classes.FilterPositionsRow}>
      <Grid container item xs={8} />
      <Grid container item xs={4}>
        <Grid item xs={12}>
          <label
            className={combineClasses([
              classes.Bold,
              classes.UpperCase,
              classes.applyToAllLabel,
            ])}
            htmlFor="select-accounting-template"
          >
            {t('massUpdatesPage.applyTemplateLabel')}
          </label>
        </Grid>

        <Grid item xs={12} className={classes.ApplyAllWrapper}>
          {props.filters.positionType === anyGuid && (
            <Tooltip
              title={t('massUpdatesPage.disabledDropdownInfo')}
              placement="top"
              arrow
            >
              <div className={classes.iconWrapper}>
                <FontAwesomeIcon
                  icon={Required}
                  className={`${classes.endAdornmentIcon} ${classes.errorIcon}`}
                />
              </div>
            </Tooltip>
          )}

          <TextField
            variant="outlined"
            id="select-accounting-template"
            margin="dense"
            value={positionTemplateId}
            onChange={event => {
              setPositionTemplateId(event.target.value);
            }}
            select
            disabled={props.filters.positionType === anyGuid}
            className={classes.ApplyAllDropdown}
          >
            <MenuItem value={emptyGuid}>
              <em>{t('massUpdatesPage.selectTemplate')}</em>
            </MenuItem>

            {renderActivePositionTemplates()}
          </TextField>

          <Button
            id="apply-to-all"
            variant="contained"
            color="primary"
            title={t('global.buttons.apply')}
            onClick={handleApplyAllClick}
            className={classes.ApplyAllButton}
            disabled={
              props.filters.positionType === anyGuid ||
              positionTemplateId === emptyGuid
            }
          >
            {t('global.buttons.apply')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

ApplyTemplateToAllPositions.propTypes = {
  templateOptions: PropTypes.object,
  filters: PropTypes.object,
  handleApplyToAllAction: PropTypes.func,
};
